import React, { useState } from "react";

/** Expandable question/answer list shared by the homepage section and the FAQ page. */
export default function FaqAccordion({ faqs, defaultOpen = 0 }) {
  const [openIdx, setOpenIdx] = useState(defaultOpen);

  return (
    <div className="flex flex-col gap-5">
      {faqs.map((faq, idx) => {
        const isOpen = openIdx === idx;
        return (
          <div
            key={faq.id ?? idx}
            className={`border transition-all duration-300 rounded-[10px] overflow-hidden ${
              isOpen
                ? 'border-primary/50 shadow-sm bg-gray-50 transform scale-[1.01]'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <button
              onClick={() => setOpenIdx(isOpen ? null : idx)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 p-6 md:p-8 text-left focus:outline-none"
            >
              <span className={`text-lg md:text-xl font-bold transition-colors duration-300 ${isOpen ? 'text-primary' : 'text-[#0b0f19]'}`}>
                {faq.question}
              </span>
              <div className={`w-8 h-8 rounded-full border flex items-center justify-center shrink-0 transition-all duration-500 ${isOpen ? 'bg-primary border-primary text-white rotate-45' : 'border-gray-300 text-gray-400'}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14m-7-7h14"></path>
                </svg>
              </div>
            </button>
            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[1200px] opacity-100' : 'max-h-0 opacity-0'}`}
            >
              <div className="p-6 md:p-8 pt-0 text-gray-500 text-lg leading-relaxed whitespace-pre-line">
                {faq.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
